module.exports = __webpack_public_path__ + "static/media/title-bg-21.3ed47b87.jpg";